module.exports = __webpack_public_path__ + "94b9489d.webp";